export default "__VITE_ASSET__Dkwx9p8f__"